import { Flex } from '@components';
import Card from '@components/Card/Card';
import { styled } from '@mui/material';

export const Container = styled(Flex)(({ theme }) => ({
  width: '100%',
  height: '100%',
  flex: 1,
  flexDirection: 'row',
  flexWrap: 'wrap',
  marginTop: theme.spacing(16),
  rowGap: theme.spacing(7),
  paddingBottom: theme.spacing(12),
}));

export const ChartsContainer = styled(Flex)(({ theme }) => ({
  flex: 1,
  gap: theme.spacing(7),
  minWidth: '100%',
  flexWrap: 'nowrap',
  [theme.breakpoints.down('lg')]: {
    flexWrap: 'wrap',
  },
}));

export const HistoricalChartContainer = styled(Flex)(({ theme }) => ({
  flex: '1 0 auto',
  height: 400,
  minWidth: '100%',
  position: 'relative',
  width: 'auto',
  [theme.breakpoints.down('md')]: {
    width: '100%',
  },
}));

export const QuarterlyUpdateTextContainer = styled(Flex)(({ theme }) => ({
  top: 0,
  left: 0,
  position: 'absolute',
  height: '100%',
  width: '100%',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '10%',
  textAlign: 'center',
}));

export const PieChartContainer = styled(Flex)(({ theme }) => ({
  flex: '1 0 auto',
  height: 300,
  width: '50%',
  [theme.breakpoints.down('md')]: {
    width: '100%',
  },
  [theme.breakpoints.down('sm')]: {
    height: 350,
  },
}));

export const ExposureAndBreakdownContainer = styled(Flex)(({ theme }) => ({
  position: 'relative',
  minWidth: '100%',
  flex: 1,
  alignItems: 'flex-start',
  flexWrap: 'wrap',
  gap: theme.spacing(7),
}));

export const InfoCardsContainer = styled(Flex)(({ theme }) => ({
  width: '100%',
  gap: theme.spacing(7),
  overflowX: 'auto',
  [theme.breakpoints.down('sm')]: {
    maxWidth: '100%',
  },
}));

export const StyledCard = styled(Card)(({ theme }) => ({
  minWidth: 220,
  [theme.breakpoints.down('sm')]: {
    minWidth: 220,
  },
}));
